import { Component, OnInit } from '@angular/core';
import { UserNotification } from '../../objects/UserNotification';
import { HttpPlus } from '../../http-plus';
import { SharedService } from 'src/app/_shared/shared.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.scss'],
  imports: [CommonModule]
})
export class UserNotificationsComponent {

  notifications: UserNotification[] = []

  constructor(public shared: SharedService, private http: HttpPlus) {
    this.shared.rightsAllFirstNotNull.subscribe(() => {
      this.refreshNotifications()
    });
  }


  async refreshNotifications() {
    const response: any = await this.http.get(`msg/notifications`)
    this.notifications = response as UserNotification[]
  }

  checkNotification(notif: UserNotification, index: number, event: Event, xBtn: boolean = false) {
    if (xBtn) {
      event.stopPropagation()
      event.preventDefault()
    }else if(!notif.url) {
      event.preventDefault()
      return
    }
    this.http.post(`msg/checkNotification`, { hideLoader: true, id_notification: notif.id_notification })
    this.notifications.splice(index, 1)
  }
}